module.exports = __webpack_public_path__ + "img/820.7e02fa76.gif";